export const parseBoolean = (value?: string) => {
    return value && value.toLowerCase() === 'true'
}
let urlDomain = window.location.hostname.split('.').slice(-2).join('.') || "timespanel.in";
/**
 * .env variables
 */
export const IS_PRODUCTION = parseBoolean(process.env.REACT_APP_IS_PRODUCTION)
export const CTW_API_ENDPOINT = process.env.REACT_APP_CTW_API_ENDPOINT || "https://60243e05-dca3-48d0-bbcf-d6de40fd3093.mock.pstmn.io"
export const CTW_MOCK_API_ENDPOINT = process.env.REACT_APP_CTW_MOCK_API_ENDPOINT || ""
export const META_APP_ID = process.env.REACT_APP_META_APP_ID || ""
export const CT_API_ENDPOINT = process.env.REACT_APP_CT_API_ENDPOINT || ""
export const CTW_NODE_API_ENDPOINT = process.env.REACT_APP_CTW_NODE_API_ENDPOINT || ""
export const CLASSIFIED_API_ENDPOINT = process.env.REACT_APP_CLASSIFIED_API_ENDPOINT || ""
export const ORG_ID = process.env.REACT_APP_ORG_ID || ""
const calculatedDomain = urlDomain.split('.')[1] === 'localhost' || urlDomain.split('.')[1] === 'timesmobile'
    ? "timespanel.in"
    : "timespanel.in";

export const ADMIN_BASE_API_ENDPOINT = `https://services.${calculatedDomain}`;

export const API_ENDPOINTS = {
    ADMIN: {
        GET_PUBLIC_ORG_DETAIL: 'public/get-org-public-data'
    }
} as const


export const LOCAL_ACCESS_TOKEN_KEY = 'access-token'
